import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import styled, { withTheme } from 'styled-components'
import { Visible, useScreenClass } from 'react-grid-system'
import { Link } from 'react-router-dom'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion'

import { IconButton } from 'adl'

import { VividGradient } from 'adl'

const MenuShownContext = React.createContext(false)

const LeftNavigation = styled(VividGradient)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${props => props.theme.dimensions.leftMenuWidth}px;
  padding-top: 4rem;
  z-index: 100;
  transition: transform 250ms ease;

  .accordion__button,
  .accordion__item a,
  ul li a {
    display: block;
    text-decoration: none;
    padding: 0.75rem 1rem;
    color: rgba(255, 255, 255, 0.75) !important;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    &:hover {
      color: white !important;
      background-color: rgba(255, 255, 255, 0.2);
      border-bottom: 1px solid transparent;
    }

    &:focus {
      outline: none;
    }
  }

  .accordion__item ul li a {
    background-color: rgba(0, 0, 0, 0.2);
  }

  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
`

const ChevronRight = () => (
  <i className="icon-chevron-down" style={{ float: 'right' }} />
)

export default withTheme(({ theme, onHide }) => {
  const show = useContext(MenuShownContext)
  const screenClass = useScreenClass()
  const dispatch = useDispatch()

  return (
    <LeftNavigation
      style={{
        transform: `translateX(${
          ['xs', 'sm', 'md'].includes(screenClass)
            ? show
              ? '0%'
              : '-100%'
            : '0%'
        })`
      }}
    >
      <Visible xs sm md>
        <IconButton
          style={{ position: 'absolute', top: 8, right: 8 }}
          onClick={onHide}
          iconColor="white"
        >
          <i className="icon-close" />
        </IconButton>
      </Visible>
      <img
        src={theme.branding.logoInverse}
        width="180"
        style={{
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: 32
        }}
        alt="Inverted brand logo"
      />

      <Accordion allowZeroExpanded>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              Accounts
              <ChevronRight />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <ul>
              <li>
                <Link to="/accounts" onClick={onHide}>
                  Account Summary
                </Link>
              </li>
              <li>
                <Link to="/statements" onClick={onHide}>
                  Statements &amp; Documents
                </Link>
              </li>
              <li>
                <Link to="/download-transactions" onClick={onHide}>
                  Download Transactions
                </Link>
              </li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
          <Link to="/move-money" onClick={onHide}>
            Move Money
          </Link>
        </AccordionItem>
        <AccordionItem>
          <Link to="/cards" onClick={onHide}>
            Card Services
          </Link>
        </AccordionItem>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              Check Services
              <ChevronRight />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <ul>
              <li>
                <Link to="/stop-checks" onClick={onHide}>
                  Stop a Check
                </Link>
              </li>
              <li>
                <Link to="/reorder-checks" onClick={onHide}>
                  Reorder Checks
                </Link>
              </li>
            </ul>
          </AccordionItemPanel>
         </AccordionItem>
        <AccordionItem>
          <Link to="/settings" onClick={onHide}>
            Settings
          </Link>
        </AccordionItem>
        <AccordionItem>
          <Link to="/profile" onClick={onHide}>
            Profile
          </Link>
        </AccordionItem>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              Customer Service
              <ChevronRight />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <ul>
              <li>
                <Link to="/secure-messages" onClick={onHide}>
                  Secure Messages
                </Link>
              </li>
              <li>
                <Link to="/locations" onClick={onHide}>
                  Locations
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={onHide}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              Personal Analytics
              <ChevronRight />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <ul>
              <li>
                <Link to="/budgeting" onClick={onHide}>
                  Budgeting
                </Link>
              </li>
              <li>
                <Link to="/transactions" onClick={onHide}>
                  Transactions
                </Link>
              </li>
              <li>
                <Link to="/goals" onClick={onHide}>
                  Goals
                </Link>
              </li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem>
          <Link to="/alerts" onClick={onHide}>
            Alerts
          </Link>
        </AccordionItem>
        <AccordionItem>
          <Link
            to="/signed-out"
            onClick={() => {
              dispatch({
                type: 'USER_LOGOUT'
              })
              onHide()
            }}
          >
            Sign Out
          </Link>
        </AccordionItem>
      </Accordion>
    </LeftNavigation>
  )
})

export { MenuShownContext }
